export default function CreateBookingLoading({ loadingText }) {
  return (
    <div className="popup-message-overlay">
      <div className="loader-modal">
        <p>{loadingText}</p>
        <div className="loader"></div>
      </div>
    </div>
  );
}
